<div class="dropdown" data-sveltekit-preload-data="">
  <div
    dir="ltr"
    tabindex="0"
    role="button"
    class="link link-hover text-base-content/60 relative -top-1 inline-block font-mono text-[0.625rem]"
  >
    1.0.0.25
    <svg-icon
      src="./assets/icons/chevron-down.svg"
      [svgClass]="'text-base-content/60 -mt-0.25 hidden size-2 fill-current sm:inline-block'"
    ></svg-icon>
  </div>
  <ul
    tabindex="0"
    class="dropdown-content menu menu-sm bg-base-200 rounded-box mt-7 w-45 border-[length:var(--border)] border-white/5 p-2 shadow-2xl outline-[length:var(--border)] outline-black/5"
    [ngClass]="classMenu"
  >
    <li>
      <a routerLink="/docs/changelog/" routerLinkActive="active">
        <svg-icon src="./assets/icons/history.svg"></svg-icon>Changelog
      </a>
    </li>
    <li></li>
    <li>
      <a routerLink="/docs/v1/" routerLinkActive="active">
        <svg-icon
          src="./assets/icons/heroicons/optimized/24/outline/bolt.svg"
          [svgClass]="'h-4 w-4 text-base-content'"
        ></svg-icon>
        Release notes v1.x.25
      </a>
    </li>
    <li></li>
    <li>
      <a
        target="_blank"
        rel="noopener, noreferrer"
        href="https://local.audio-analyzer.com:4201/analyzer"
      >
        <svg-icon
          src="./assets/icons/heroicons/optimized/24/outline/arrow-top-right-on-square.svg"
          [svgClass]="'h-4 w-4 text-base-content'"
        ></svg-icon>
        Version 1.x
      </a>
    </li>
  </ul>
</div>
